import request from '@/utils/seftRequest';
import TTrequest from '@/utils/ttRequest';

// 查询线索列表 /tt/v2/task/task-list
export function qryTaskList(data) {
  return TTrequest('/tt/v2/task/task-list', {
    method: 'POST',
    body: {
      ...data,
      nodeNo: 'DSCM',
    },
  });
}

// 取消TT单 drm/ding/troubleTicket/workOrderCompleteBsnl
export function workOrderComplete(data) {
  return request('/ding/troubleTicket/workOrderCompleteBsnl', {
    method: 'POST',
    body: data,
  });
}

// create order的时候tt暂存custId
export function leadSaveCustId(data) {
  return TTrequest('/tt/v1/order/modify', {
    method: 'POST',
    body: data,
  });
}
